import {
	FormControl,
	FormHelperText,
	InputLabel,
	Select,
} from "@material-ui/core";
import React from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { useFieldControl } from "./FieldHelper";

export default function SelectField<T extends FieldValues>(props: {
	label: string;
	name: string;
	control: Control<T>;
	disabled?: boolean;
	children?: (JSX.Element | null)[];
}) {
	const { error, value } = useFieldControl(props.control, props.name);

	return (
		<FormControl
			variant="outlined"
			error={!!error}
			disabled={props.disabled}
			fullWidth
		>
			<InputLabel id={`${props.name}-label`}>{props.label}</InputLabel>
			<Controller
				as={Select}
				labelId={`${props.name}-label`}
				control={props.control}
				name={props.name}
				value={value}
				label={props.label}
			>
				{props.children}
			</Controller>
			{error && <FormHelperText error={true}>{error.message}</FormHelperText>}
		</FormControl>
	);
}
